type MemberOption = { user: { id: string; name: string | null; email: string } };
type SiteOption = { id: string; name: string; memberIds: string[] };

export function membersAssignableToSite<T extends MemberOption>(members: T[], sites: SiteOption[], siteId: string): T[] {
  if (!siteId) return members;
  const site = sites.find(item => item.id === siteId);
  if (!site) return [];
  const memberIds = new Set(site.memberIds);
  return members.filter(item => memberIds.has(item.user.id));
}
